import { render, staticRenderFns } from "./LgOrderTypeSelection.vue?vue&type=template&id=b5684e62&scoped=true&"
import script from "./LgOrderTypeSelection.vue?vue&type=script&lang=js&"
export * from "./LgOrderTypeSelection.vue?vue&type=script&lang=js&"
import style0 from "./LgOrderTypeSelection.vue?vue&type=style&index=0&id=b5684e62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5684e62",
  null
  
)

export default component.exports